import React from "react";
import { Link, useLocation } from "react-router-dom";
import { resolveBackTo } from "../../lib/navigation";
import { usePreviousPath } from "./NavigationHistory";

function readFromState(state) {
  if (!state || typeof state !== "object") return "";
  if (typeof state.from === "string") return state.from;
  if (state.from && typeof state.from.pathname === "string") {
    return `${state.from.pathname}${state.from.search || ""}`;
  }
  return "";
}

export default function BackButton({
  to,
  fallbackTo,
  strict = false,
  label = "Back",
  className = "",
}) {
  const location = useLocation();
  const previousPath = usePreviousPath();
  const from = readFromState(location.state) || previousPath;
  const destination = resolveBackTo({
    pathname: location.pathname,
    fallbackTo: to || fallbackTo,
    from,
    strictParent: strict,
  });

  return (
    <Link
      to={destination}
      className={`btn btn-outline-secondary btn-sm agent-back-btn ${className}`.trim()}
      aria-label={label}
    >
      <iconify-icon icon="solar:arrow-left-outline" aria-hidden="true"></iconify-icon>
      <span>{label}</span>
    </Link>
  );
}
